import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { IS_TAURI } from './config';
import { setupTauriFetchBridge } from './utils/tauriFetch';
import { installResizeObserverErrorFilter } from './utils/resizeObserverError';

installResizeObserverErrorFilter();
setupTauriFetchBridge();

function registerProductionServiceWorker(): void {
    if (IS_TAURI || process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
        return;
    }
    // Push subscription still registers this same worker on demand.
    // A failed boot registration leaves the page on the network.
    navigator.serviceWorker.register('/service-worker.js').catch((error: unknown) => {
        if (!(error instanceof Error)) {
            throw error;
        }
    });
}

async function bootstrap() {
    registerProductionServiceWorker();
    // DEV-ONLY: optionally seed a mock admin session so the local dev environment
    // starts signed in. Wrapped in a NODE_ENV guard so it (and the imported module)
    // is removed from production builds by dead-code elimination.
    if (process.env.NODE_ENV === 'development') {
        const { seedDevAdminLogin } = await import('./utils/devAutoLogin');
        seedDevAdminLogin();
    }

    const container = document.getElementById('root');
    if (!container) throw new Error('Failed to find the root element');
    const root = createRoot(container);

    root.render(
        <App />
    );
}

void bootstrap(); 